import { useState } from 'react';
import { Dropdown, DropdownItemText, Form, FormCheck, FormControl } from 'react-bootstrap';

export type FilterOption = { id: string; name: string };

type Props = {
  label: string; // e.g. "Pipeline"
  allLabel?: string; // e.g. "All pipelines"
  options: FilterOption[];
  selected: string[];
  onChange: (ids: string[]) => void;
};

export default function MapFilterDropdown({
  label,
  allLabel = 'All',
  options,
  selected,
  onChange,
}: Props) {
  const [search, setSearch] = useState('');

  const filtered = options
    .filter(o => o.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => a.name.localeCompare(b.name));

  const toggle = (id: string, checked: boolean) =>
    onChange(checked ? [...selected, id] : selected.filter(x => x !== id));

  const toggleLabel = selected.length === 0 ? allLabel : `${selected.length} selected`;

  return (
    <Form.Group className={'w-100'}>
      <Dropdown autoClose="outside" className={'w-100'}>
        <Dropdown.Toggle variant="outline-secondary" size="sm" className={'w-100'}>
          {toggleLabel}
        </Dropdown.Toggle>
        <Dropdown.Menu className="border-secondary" style={{ minWidth: 260 }}>
          <DropdownItemText>
            <FormControl
              autoFocus
              size="sm"
              placeholder="Search"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </DropdownItemText>

          <DropdownItemText>
            <div className="form-check d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input"
                id={`filter-all-${label}`}
                checked={selected.length === 0}
                onChange={() => onChange([])}
              />
              <label className="form-check-label fw-semibold" htmlFor={`filter-all-${label}`}>
                {allLabel}
              </label>
            </div>
          </DropdownItemText>

          <div style={{ maxHeight: 280, overflowY: 'auto' }}>
            {filtered.map(o => (
              <DropdownItemText key={o.id}>
                <FormCheck
                  label={o.name}
                  id={`${label}-${o.id}`}
                  checked={selected.includes(o.id)}
                  onChange={e => toggle(o.id, e.target.checked)}
                />
              </DropdownItemText>
            ))}
            {filtered.length === 0 && (
              <DropdownItemText className="text-muted small">No options</DropdownItemText>
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
}
